<template>
  <status-badge v-if="dateToCheck == null || settlementId == null" color="grey lighten-2">
    {{ trans('general.unknown') }}
  </status-badge>
  <status-badge v-else-if="settlementId === settlementIdToCheck" color="light-green lighten-2">
    {{ trans('booking.settleDoneTrue') }}
  </status-badge>
  <status-badge v-else-if="isDateForSettlement" color="amber lighten-2">
    {{ trans('booking.settleDoneFalse') }}
  </status-badge>
  <booking-status-canceled v-else-if="type === 'settle' && booking !== null && booking.canceled"></booking-status-canceled>
  <status-badge v-else color="grey lighten-2">
    {{ formatDate(this.dateToCheck, 'MMMM YYYY') }}
  </status-badge>
</template>

<script>

import {LocaleUtils} from '@/utils/locale-utils';
import StatusBadge from '@/components/StatusBadge';
import {DateUtils} from '@/utils/date-utils';
import BookingStatusCanceled from './BookingStatusCanceled';

export default {
  name: 'BookingSettlementStatus',
  components: {BookingStatusCanceled, StatusBadge},
  mixins: [
    LocaleUtils,
    DateUtils
  ],
  props: {
    booking: {
      type: Object
    },
    settlement: {
      type: Object
    },
    type: {
      type: String
    }
  },
  computed: {
    dateToCheck() {
      if(this.booking != null) {
        switch (this.type) {
          case 'provision': return this.booking.provisionDate;
          case 'settle': return this.booking.settleDate;
        }
      }
      return null;
    },
    settlementIdToCheck() {
      if(this.booking != null) {
        switch (this.type) {
          case 'provision': return this.booking.provisionSettlementId;
          case 'settle': return this.booking.settleSettlementId;
        }
      }
      return null;
    },
    settlementId() {
      if(this.settlement != null) {
         return parseInt(this.settlement.id);
      }
      return null;
    },
    isDateForSettlement() {
      if(this.dateToCheck != null && this.settlement != null && this.settlement.year != null && this.settlement.month != null) {
        return this.isDateInYearAndMonth(this.dateToCheck, this.settlement.year, this.settlement.month)
      }
      return false;
    }
  },
}
</script>
